<script>
import { kebabCase, filter, map, each, find } from "lodash";

import Modals from "./modals";
export default {
    components: {
        ...Modals
    },
    data() {
        return {
            showing_modals: []
        };
    },
    created() {
        // let mapping = {};
        console.log(Modals);
        each(Modals, (modal, key) => {
            console.log(modal, key);
            this.showing_modals.push({
                id: key,
                show: false,
                loaded: false,
                loading: false
            });
        });
        // this.$on("modal-loaded", this.modalLoaded);
    },
    methods: {
        showModal(id, options) {
            let modal = this.findModal(id);
            // console.log(id, options);
            // console.log(modal);
            // modal.show = true;
            if (!modal.loaded) {
                modal.loading = true;
                // NProgress.start();
            }
            modal.loaded = true;
            modal.options = options;
            modal.show = true;
        },
        hideModal(id) {
            let modal = this.findModal(id);
            modal.show = false;
            // console.log(id);
        },
        findModal(id) {
            let modal = find(this.showing_modals, function(value, key) {
                console.log(key);
                return id == kebabCase(value.id) + "-modal" || value.id == id;
            });
            return modal;
        },
        modalLoaded(id) {
            let modal = this.findModal(id);
            modal.loading = false;
            // NProgress.done();
        }
    },
    render(h) {
        let modals = filter(this.showing_modals, { loaded: true });
        // console.log(modals);
        let render = map(modals, modal => {
            let component = h(modal.id, {
                props: modal.options
                    ? { value: modal.show, modalId: modal.id, ...modal.options }
                    : { value: modal.show },
                on: {
                    input: value => {
                        modal.show = value;
                        // console.log(event);
                        // this.$emit("input", event.target.value);
                    },
                    "modal-loaded": this.modalLoaded
                }
            });
            return component;
        });
        // console.log(render);
        return h("div", { class: "modal-manager-container" }, render);
    },
    beforeDestroy() {
        // this.$off("modal-loaded", this.modalLoaded);
    }
};
</script>
